module.exports = __webpack_public_path__ + "static/847978026.8688f960.jpg";